import React from 'react'
import { Box, Typography } from '@mui/material'
import MuiTooltip from '@mui/material/Tooltip'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import type { FeatureCheckResult } from '@hapana/shared/schemas/entitlements/entitlement-result.schema'
import { upgradeTooltipStyles as styles } from './upgrade-tooltip.styles'

export interface UpgradeTooltipProps {
  checkResult: FeatureCheckResult | undefined
  children: React.ReactElement
  placement?: 'top' | 'bottom' | 'left' | 'right'
}

export const UpgradeTooltip: React.FC<UpgradeTooltipProps> = ({
  checkResult,
  children,
  placement = 'top',
}) => {
  // Defensive: a missing checkResult (a caller that renders a lock but forgot to pass one) must never
  // crash the page — just render the children without a tooltip.
  if (!checkResult || checkResult.entitled || !checkResult.upgradeInfo) {
    return children
  }

  return (
    <MuiTooltip
      title={
        <Box sx={styles.content}>
          <LockOutlinedIcon sx={styles.lockIcon} />
          <Typography variant="body2">{checkResult.upgradeInfo.message}</Typography>
        </Box>
      }
      placement={placement}
      arrow
    >
      {children}
    </MuiTooltip>
  )
}
